/* Idea from Stack Overflow https://stackoverflow.com/a/51683226  */
export class SwitcherBtnControl {
  constructor(onBeforeSwitch, onAfterSwitch) {
    this.onBeforeSwitch = onBeforeSwitch;
    this.onAfterSwitch = onAfterSwitch;
    this._className = 'mapboxgl-style-switcher';
    this._title = 'Map menu';
    this.styles = [];
    this.currentStyle = null;

    // this._eventHandler = three;
    // this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultPosition() {
    return 'top-left';
  }

  initStyles(updatedStyles, selectedStyle) {
    this.styles = updatedStyles;
    selectedStyle = updatedStyles.find((item) => item.title === selectedStyle)
      ? selectedStyle
      : 'Mapbox Satellite';

    // eslint-disable-next-line no-restricted-syntax
    for (const style of this.styles) {
      if (style.title === selectedStyle) {
        this.onSelectStyle(this.styles.find((item) => item.title === selectedStyle));
      }
    }
  }

  onSelectStyle(target) {
    this.onBeforeSwitch();

    if (this.map.getStyle() !== undefined) {
      if (this.map.getLayer('sky')) {
        this.map.removeLayer('sky');
      }
      if (this.map.getLayer('building')) {
        this.map.removeLayer('building');
      }
      if (this.map.getLayer('3d-buildings')) {
        this.map.removeLayer('3d-buildings');
      }
    }

    this.map.setStyle(target.uri, { diff: false });

    this.onAfterSwitch();
  }

  onAdd(map) {
    this.map = map;
    this._btn = document.createElement('button');
    this._btn.className = `mapboxgl-ctrl-icon ${this._className}`;
    this._btn.type = 'button';
    this._btn.title = this._title;
    this._btn.onclick = this.onDocumentClick;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    this._container.appendChild(this._btn);

    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}
